import { createContext, useContext } from 'react';

export const createGenericContext = <T>(defaultContext: T | null = null) => {
  // Create a context with a generic parameter or undefined
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const genericContext = createContext<T | undefined>(defaultContext!);

  // Check if the value provided to the context is defined or throw an error
  const useGenericContext = () => {
    const context = useContext(genericContext);
    if (!context) {
      throw new Error('useGenericContext must be used within a Provider');
    }
    return context;
  };

  return [useGenericContext, genericContext.Provider, genericContext] as const;
};
